import { CodeBook } from "@king-ict/eupisi-ui/models";
import {
  getYearFromDate,
  codeBookToSelectData,
} from "@king-ict/eupisi-ui/utils";

export const generateBirthYearSelectData = () => {
  const arr = [] as CodeBook[];
  const year = getYearFromDate(new Date());

  for (let i = year - 100; i <= year - 12; i++) {
    arr.push({ id: i, name: i.toString() });
  }

  return codeBookToSelectData(arr);
};
